import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Row, Col, Card} from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import { List as EditContact } from '../contact/Lista';
import {item} from "../../../lib/api/club";

export const ContactHome = () => {
    const {club_guid} = useParams();
    const [club, setClub] = useState({});
    console.clear();
    console.log('xxxxx',club_guid)
    useEffect(() => {
        (async () => {
            try {
                const rowClubs = await item({"club_guid": club_guid});
                console.log('rowClubs',rowClubs[0])
                setClub(rowClubs[0]);
            } catch (error) {
                console.error("greska");
            }
        })();
    }, [club_guid]);

    return (
        <Row>
            <EditContact
                initPartner={club}
            />
        </Row>
    );
};

export default ContactHome;



